import { Button, Text } from 'components';
import { TEXT_STRING } from '../../../constants';
import PlanCard from './PlanCard';

const MENU_STR = TEXT_STRING.PRICE_LIST;
const miniList = MENU_STR.PLAN_LIST;
const detailList = MENU_STR.PLAN_DETAIL_LIST;

type Props = {
  isExpanded: boolean;
  handleToggle: () => void;
};

export default function PlanContainer({ isExpanded, handleToggle }: Props) {
  return (
    <div className="w-full p-3 mt-2 rounded-lg border border-neutral-300 shadow-[0_1px_4px_rgba(0,0,0,0.1)]">
      <Text center fontWeight="font-bold" fontSize={16}>
        {MENU_STR.PLAN_LIST_TITLE}
      </Text>

      <div className="grid grid-cols-2 gap-4 mt-4">
        {miniList.map((p, i) => (
          <div key={`plan-mini-${i}`} className="bg-neutral-25 rounded p-2">
            <Text
              center
              fontWeight="font-medium"
              textColor="text-neutral-550"
              fontSize={12}
            >
              {p.name}
            </Text>
            <Text
              center
              fontWeight="font-bold"
              textColor="text-primary"
              fontSize={12}
            >
              {p.price}
            </Text>
          </div>
        ))}
      </div>

      <Button
        onClick={handleToggle}
        bgColor="transparent"
        className="mx-auto pl-8 mt-4"
        iconRight="twinDown"
        iconClassName={`transition-all duration-300 ${
          isExpanded && '-rotate-180'
        }`}
      >
        <Text className="tracking-wide" fontWeight="font-md" fontSize={14}>
          {MENU_STR.MORE_PLAN}
        </Text>
      </Button>
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isExpanded
            ? 'grid-rows-[1fr] opacity-100'
            : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          {detailList.map((plan, i) => (
            <PlanCard key={`plan-card-${i}`} plan={plan} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
